import { render } from "./clients.vue?vue&type=template&id=4544c542&ts=true"
import script from "./clients.vue?vue&type=script&lang=ts"
export * from "./clients.vue?vue&type=script&lang=ts"

import "./clients.vue?vue&type=style&index=0&id=4544c542&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__